import Model, { attr, type HasMany, hasMany } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';
import type {
  Rsbaserate,
  Rscancellationpolicy,
  Rspattern,
  Rsstrategy,
  Rssubtype,
  Rstype,
} from 'lumen/models';

export default class RateStrategy extends Model {
  [Type] = 'rate-strategy' as const;

  @hasMany('rsbaserates', { async: false, inverse: null })
  declare rsbaserates: HasMany<Rsbaserate>;

  @hasMany('rscancellationpolicy', { async: false, inverse: 'rateStrategy' })
  declare rscancellationpolicies: HasMany<Rscancellationpolicy>;

  @hasMany('rspattern', { async: false, inverse: null })
  declare rspatterns: HasMany<Rspattern>;

  @hasMany('rsstrategy', { async: false, inverse: 'rateStrategy' })
  declare rsstrategies: HasMany<Rsstrategy>;

  @hasMany('rssubtype', { async: false, inverse: null })
  declare rssubtypes: HasMany<Rssubtype>;

  @hasMany('rstype', { async: false, inverse: null })
  declare rstypes: HasMany<Rstype>;

  @attr('string') declare extractDate: string;
  @attr('number') declare extractDateWeekOffset: number;
}
